import { useState,useEffect } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import axios from "axios";
import _ from "lodash";
import { DEALER_LOGIN_URL,ENV_URL } from "../../Essentials/variables";
import { getADFSLoginUrl } from "../../store/apis/authApi";

function LandingLoginPage(props){

   
     const handleADFSLoginCLick = async() =>{
        await getADFSLoginUrl();

     }

    const [email,setEmail]=useState('');
    const [password,setPassword]=useState('');
    const [user,setuser] = useState([]);

    const handleSignupClick = () =>{
        props.nav('dealersignup')
    }
    const handleForgetPasswordClick = ()=>{
        props.nav('forgetpassword');
    }

    const handleLoginSubmit = (e) =>{
        // console.log("----")
        e.preventDefault();
        // setEmail('');
        // setPassword('');
        axios({
            method:'POST',
            data:{
              username:email,
              password:password
            },
            withCredentials:false,
            url:DEALER_LOGIN_URL
          })
          .then((res)=>{
            //   console.log(res.data);  //data: "Success Autheticated"
              if(res.data?.message==="Success"){
                // console.log("Saving....");
                localStorage.setItem("token", JSON.stringify(res.data["token"]));
                localStorage.setItem("userInfo",JSON.stringify(_.omit(res.data,["token"])));
                  props.nav('/gis') 
                //   props.nav('/dealeradmin') //
              }
              else{
                setuser(res.data); 
                // console.log(res.data);
              }
              // console.log(res.data.Access);
          }
          )
    }
    
    return <div>
        <MainHeader profileVisiblilty={false}/>
        <div className="pl-10">
           <h3 className="text-5xl font-normal leading-normal mt-0 mb-2 mx-72 pl-56 text-blue-900">Rural Maps</h3>
        </div>
        <div className="flex">
         <div className="flex-1 w-64 ...">
         <section className="bg-gray-50 border-4 border-indigo-200 border-r-indigo-500 dark:bg-gray-900 py-32 pb-36">
  <div className="flex flex-col items-center   justify-center px-6 pb-8 mx-auto  lg:py-0">
      <h1 className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          Dealer Login   
      </h1>
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Sign in to your account
              </h1>
              <form className="space-y-4 md:space-y-6" onSubmit={handleLoginSubmit}>
                  <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your email</label>
                      <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required=""/>
                  </div>
                  <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)}  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div className="flex items-center justify-between">
                      <div className="flex items-start">
                          <div className="flex items-center h-5">
                          </div>
                          <div className="ml-3 text-sm">
                          </div>
                      </div>
                      <button href="#" className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500" onClick={handleForgetPasswordClick}>Forgot password?</button>
                  </div>
                  <button type="submit" className="w-full text-white bg-[#2563eb] hover:bg-[#1d4ed8] focus:ring-4 focus:outline-none focus:ring-[#93c5fd] font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Sign in</button>
                  <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                      Don’t have an account yet? <button onClick={handleSignupClick} className="font-medium text-primary-600 hover:underline dark:text-primary-500">Sign up</button>
                  </p>
                  <h6>{user}</h6>
              </form>
          </div>
      </div>
  </div>
</section>
         </div>
         <div className="flex-1 w-32 ...">
         <section className="bg-gray-50 border-4 border-indigo-200 border-l-indigo-500 dark:bg-gray-900 py-32 pb-56">
  <div className="flex flex-col items-center justify-center px-6 py-8 pb-2 mx-auto lg:py-0">
      <h1 className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          Employee Login
      </h1>
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8 pb-8">
              <h1 className="py-4 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Sign in using ADFS account
              </h1>
              <h6>INSTRUCTIONS</h6>
              <p>Make sure you have active ADFS Account</p>
              <p>Your First Login will raise request for website access</p>
              
              <button onClick={handleADFSLoginCLick} type="submit" className="w-full text-white bg-gradient-to-r from-sky-400 to-blue-500 hover:bg-[#1d4ed8] focus:ring-4 focus:outline-none focus:ring-[#93c5fd] font-medium rounded-lg text-sm px-5 py-6 mb-2 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">ADFS Login</button>
          </div>
      </div>
  </div>
</section>
         </div>
       </div>
    </div>
}

export default LandingLoginPage;